export const DEV = import.meta.env.DEV
